import React, { Component } from 'react';
import PropTypes from 'prop-types';
import idGenerator from 'react-id-generator';

import RadioInput from './styled/RadioInput';
import RadioWrapper from './styled/RadioWrapper';

class RadioField extends Component {
  constructor(props) {
    super(props);
    this.id = props.id || idGenerator();
    this.handleCheck = this.handleCheck.bind(this);
  }

  handleCheck(e) {
    const { onChange } = this.props;
    onChange(e.target.value);
  }

  render() {
    const {
      value,
      isDisabled,
      isChecked,
      children,
      withFilledBackgroundWhenUnselected,
      withNoBorderWhenUnselected,
    } = this.props;
    return (
      <RadioWrapper>
        <RadioInput
          id={this.id}
          type="radio"
          value={value}
          onChange={this.handleCheck}
          disabled={isDisabled}
          checked={isChecked}
          withFilledBackgroundWhenUnselected={withFilledBackgroundWhenUnselected}
          withNoBorderWhenUnselected={withNoBorderWhenUnselected}
        />
        <label htmlFor={this.id}>{children}</label>
      </RadioWrapper>
    );
  }
}

RadioField.propTypes = {
  onChange: PropTypes.func,
  value: PropTypes.string,
  isDisabled: PropTypes.bool,
  isChecked: PropTypes.bool,
  children: PropTypes.string,
  withFilledBackgroundWhenUnselected: PropTypes.bool,
  withNoBorderWhenUnselected: PropTypes.bool,
};

RadioField.defaultProps = {
  children: null,
  onChange: () => {},
  value: '',
  isChecked: false,
  isDisabled: false,
  withFilledBackgroundWhenUnselected: false,
  withNoBorderWhenUnselected: false,
};

export default RadioField;
